
export default {

    getShops(context, success, error) {
        context.$http.get('shops').then(success, error)
    }

}


// WEBPACK FOOTER //
// ./src/services/shops/index.js